<template>
  <v-app class="yc-application-user-guide overflow-hidden">
    <v-app-bar class="yc-app-bar" fixed height="56" max-height="56" backgroud-color="#FFFFFF" color="#FFFFFF">
      <v-app-bar-nav-icon
          class="d-block d-lg-none"
          @click="openNavbar"
      ></v-app-bar-nav-icon>
      <img  height="18" :src="logoUrl"  @click="reloadWindows('/help')" style="cursor: pointer"/>
      <span class="d-none d-lg-block v-divider-app-bar mr-4 ml-4"></span>
      <p class="txt-subtitle d-none d-lg-block justify-start align-left ma-0"
         style="min-width: 150px;width: 100%;max-width: 400px;">User Portal & Agent Guide</p>
      <div class="yc-search ml-12">
        <v-text-field v-model="search"
                      :placeholder="'Search by keyword...'"
                      height="40"
                      clearable
                      color="black"
                      @keydown.enter="goToRouter('/help/search', search)"
                      class="yc-search-input mr-lg-4 mr-0">
          <template v-slot:prepend-inner>
            <v-icon class="icon-search" style="margin-top:2px"></v-icon>
          </template>
        </v-text-field>
      </div>
      <v-spacer/>
      <div class="d-none d-lg-flex justify-center align-center mr-1" style="min-width: 100px;cursor: pointer"
           @click="goToRouter('/help/contact')">
        <span
            class="yc-icon yc-icon--small mr-2 icon-contact"
        ></span>
        <span>Contact us</span>
      </div>
    </v-app-bar>
    <v-divider/>
    <div style="height: 56px"></div>
    <v-container class="yc-content pa-0" id="yc-content" style="max-width: 100% !important; margin: 0;">
      <router-view/>
    </v-container>
  </v-app>
</template>

<script>
import Vue from "vue"
import _ from 'lodash'
import configProvider from "@/services/configProvider";
import navBarService from "../../services/navBarService";

export default Vue.extend({
  name: "Index",
  data() {
    return {
      search: "",
      logoUrl: configProvider.get("LOGO_URL") || "",
      loading: true,
    }
  },
  methods: {
    openNavbar() {
      navBarService.open();
    },
    goToRouter(path, query = {}) {
      if (!query) {
        return;
      }
      if (path === this.$route.path && !this.$route.query) {
        return
      }
      query = {
        search: query
      }
      if (query && _.isEmpty(query.search)) {
        this.$router.push({'path': path})
      } else {
        if (query === this.$route.query) {
          return;
        }
        this.$router.push({'path': path, 'query': query})
      }
    },
    reloadWindows(url) {
      if (url === this.$route.path) {
        location.hash = ''
        location.search = ''
      } else {
        this.$router.push({path: url})
      }
    },
  },
  created() {
    const query = this.$route.query
    if (query && query.search) {
      this.search = query.search
    }
  },

})
</script>

<style lang="scss">
.text-warning {
  //color: #ffcc00!important;
  font-weight: bold !important;
}
</style>
